<div class="items-center justify-between">
  <app-page-title></app-page-title>
</div>
<fieldset disabled>
  <form class="form-validate">
    <div class="card mb-3">
      <div class="card-body">
        <h4 class="section-title">ข้อมูลบุคคล</h4>
        <hr class="divider">
        <div class="row mb-3 g-3">
          <div class="col-12">
            <div class="row align-items-center">
              <label class="col-sm-2 form-label col-form-label text-sm-end " for="cardNo">บัตรประจำตัวประชาชน</label>
              <div class="col-sm-10">
                <div class="form-check form-check-inline">
                  <input type="radio" id="hasIdCard" name="hasIdCard" class="form-check-input" [value]="true"
                         [ngModel]="profile.hasIdCard || '-'" required/>
                  <label for="hasIdCard" class="form-check-label">มีบัตรประจำตัวประชาชน</label>
                </div>
                <div class="form-check form-check-inline">
                  <input type="radio" id="hasNoIdCard" name="hasIdCard" class="form-check-input" [value]="false"
                         [ngModel]="profile.hasIdCard || '-'" required/>
                  <label for="hasNoIdCard" class="form-check-label">ไม่มีบัตรประจำตัวประชาชน</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (profile.hasIdCard) {
          <div class="row mb-3 g-3">
            <div class="col-lg-6">
              <div class="row align-items-center">
                <label class="col-sm-4 form-label col-form-label text-sm-end " for="cardNo">เลขประจำตัวประชาชน 13
                  หลัก</label>
                <div class="col-sm-8">
                  <input type="text" id="cardNo" name="cardNo"
                         class="form-control-plaintext form-control-sm"
                         readonly [ngModel]="profile.cardNo || '-'" size="13" maxlength="13" minlength="13"
                         required pattern="[A-Za-z0-9]{13}"/>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div class="row mb-3 g-3">
            <div class="col-lg-6">
              <div class="row align-items-center">
                <label class="col-sm-4 form-label col-form-label text-sm-end " for="cardNo">เลขที่หนังสือเดินทาง</label>
                <div class="col-sm-8">
                  <input type="text" id="cardNoEn" name="cardNo"
                         class="form-control-plaintext form-control-sm"
                         readonly [ngModel]="profile.cardNo || '-'"
                         maxlength="13"
                         required >
                </div>
              </div>
            </div>
          </div>
        }
        <div class="row mb-3 g-3">
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="prefixName">คำนำหน้าชื่อ</label>
              <div class="col-sm-8">
                <input type="text" class="form-control-plaintext form-control-sm" readonly
                       [value]="profile.prefixName?.title || '-'">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="firstName">ชื่อ (ไทย)</label>
              <div class="col-sm-8">
                <input type="text" id="firstName" name="firstName"
                       class="form-control-plaintext form-control-sm"
                       readonly
                       required
                       [ngModel]="profile.firstName || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="middleName">ชื่อกลาง (ไทย)</label>
              <div class="col-sm-8">
                <input type="text" id="middleName" name="middleName"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.middleName || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="lastName">นามสกุล (ไทย)</label>
              <div class="col-sm-8">
                <input type="text" id="lastName" name="lastName"
                       class="form-control-plaintext form-control-sm"
                       readonly required [ngModel]="profile.lastName || '-'"/>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="prefixNameEn">คำนำหน้าชื่อ(EN)</label>
              <div class="col-sm-8">
                <input type="text" class="form-control-plaintext form-control-sm" readonly
                       [value]="profile.prefixNameEn?.title || '-'">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="firstNameEn">ชื่อ (EN)</label>
              <div class="col-sm-8">
                <input type="text" id="firstNameEn" name="firstNameEn"
                       class="form-control-plaintext form-control-sm"
                       readonly required [ngModel]="profile.firstNameEn || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="middleNameEn">ชื่อกลาง (EN)</label>
              <div class="col-sm-8">
                <input type="text" id="middleNameEn" name="middleNameEn"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.middleNameEn || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="lastNameEn">นามสกุล (EN)</label>
              <div class="col-sm-8">
                <input type="text" id="lastNameEn" name="lastNameEn"
                       class="form-control-plaintext form-control-sm"
                       readonly required [ngModel]="profile.lastNameEn || '-'"/>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="nationality">สัญชาติ</label>
              <div class="col-sm-8">
                <input type="text" class="form-control-plaintext form-control-sm" readonly
                       [value]="profile.nationality?.name || '-'">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="birthdate">วันเดือนปีเกิด</label>
              <div class="col-sm-8">
                <input type="text" class="form-control-plaintext form-control-sm" readonly
                       [value]="profile.birthdate || '-'">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <h4 class="section-title">ที่อยู่</h4>
        <hr class="divider">
        <div class="row mb-3 g-3">
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="addressNo">บ้านเลขที่</label>
              <div class="col-sm-8">
                <input type="text" id="addressNo" name="addressNo"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.addressNo || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="moo">หมู่ที่</label>
              <div class="col-sm-8">
                <input type="text" id="moo" name="moo"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.moo || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="soi">ตรอก/ซอย</label>
              <div class="col-sm-8">
                <input type="text" id="soi" name="soi"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.soi || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="road">ถนน</label>
              <div class="col-sm-8">
                <input type="text" id="road" name="road"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.road || '-'"/>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="subdistrict">ตำบล/แขวง</label>
              <div class="col-sm-8">
                <input type="text" class="form-control-plaintext form-control-sm" readonly
                       [value]="profile.subDistrict?.name || '-'">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="district">อำเภอ/เขต</label>
              <div class="col-sm-8">
                <input type="text" id="district" name="district"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.subDistrict?.district?.name || '-' "/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="province">จังหวัด</label>
              <div class="col-sm-8">
                <input type="text" id="province" name="province"
                       class="form-control-plaintext form-control-sm" readonly
                       [ngModel]="profile.subDistrict?.district?.province?.name || '-' "/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end " for="postCode">รหัสไปรษณีย์</label>
              <div class="col-sm-8">
                <input type="text" id="postCode" name="postCode"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.postCode || '-'" maxlength="5" required
                       pattern="[0-9]{5}"/>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="phoneNo">เบอร์โทรศัพท์</label>
              <div class="col-sm-8">
                <input type="tel" id="phoneNo" name="phoneNo"
                       class="form-control-plaintext form-control-sm"
                       readonly [ngModel]="profile.phoneNo || '-'"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center">
              <label class="col-sm-4 form-label col-form-label text-sm-end" for="faxNo">โทรสาร</label>
              <div class="col-sm-8">
                <input type="tel" id="faxNo" name="faxNo"
                       class="form-control-plaintext form-control-sm" readonly [ngModel]="profile.faxNo || '-'"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <h4 class="section-title ">บทบาทผู้ใช้งาน (Role)</h4>
        <hr class="divider">
        <div class="row">
          <label class="col-sm-2 form-label col-form-label text-sm-end" for="roles"></label>
          <div class="col-sm-8">
            <div class="row">
              @for (role of roles; track role.role) {
                <div class="col-lg-6 mb-2">
                  <div class="form-check">
                    <input type="checkbox"
                           class="form-check-input"
                           [id]="'role-' + role.role"
                           [name]="'role-' + role.role"
                           readonly disabled
                           [ngModel]="selectedRoleMap[role.role]"/>
                    <label class="form-check-label" [for]="'role-' + role.role">{{ role.label }}</label>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="card-body">-->
      <!--        <h4 class="section-title">ข้อมูลบัญชีผู้ใช้งาน</h4>-->
      <!--        <hr class="divider">-->
      <!--        <div class="row align-items-center mb-3">-->
      <!--          <label class="col-md-3 col-sm-4 form-label col-form-label text-sm-end " for="email">อีเมล</label>-->
      <!--          <div class="col-md-9 col-sm-8">-->
      <!--            <div class="d-flex flex-wrap gap-2 align-items-center">-->
      <!--              <input type="email" id="email" name="email"-->
      <!--                     class="form-control-plaintext form-control-sm"-->
      <!--                     readonly-->
      <!--                     [ngModel]="profile.email"-->
      <!--                     required email-->
      <!--                     style="max-width: 400px; width: 100%;"/>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </form>
</fieldset>
